export default __webpack_public_path__ + "static/szlenk-51eded9a46d23c5026e75f7d406ded48.jpg";